export function getCreditProgressBarLabel(
  creditType: "lateness" | "cancellation",
  hasCredit: boolean
): string {
  const prefix = creditType === "cancellation" ? "Same-day cancellation" : "Lateness";
  const suffix = hasCredit ? "credit available" : "credit unavailable";
  return `${prefix} ${suffix}`;
}
